import { useMemo } from "react";
import {
  ShowButton,
  DeleteButton,
  Stack,
  EditButton,
  Button,
  Chip,
  Grid,
} from "@pankod/refine-mui";
import { Typography, useDataGrid, DataGrid, List } from "@pankod/refine-mui";
import { itIT } from "@mui/x-data-grid";
import useAuth from "contexts/AuthContext";
import useLocales from "locales/useLocales";

export default function CompList() {
  const { currentLang, defaultLang } = useLocales();

  //const owner = JSON.parse(localStorage.getItem("user")).id;
  const auth = useAuth();
  const owner = auth.user?.id ? auth.user?.id : "";

  /*let filter = [];
  if (auth.user.role.name != "admin")
    filter = [
      {
        field: "facility.owner.id",
        operator: "eq",
        value: owner,
      },
    ];*/
  let filter = [
    {
      field: "facility.owner.id",
      operator: "eq",
      value: owner,
    },
  ];

  const { dataGridProps, sortingMode, sortModel, onSortModelChange } =
    useDataGrid({
      /*metaData: {
        locale: "en", //le prenotazioni non hanno lingue associate, prendo il locale di default
        populate: ["coupon", "user", "accommodation", "accommodation.facility"],
      },*/
      metaData: {
        locale: defaultLang,
        populate: ["user", "booking_items", "booking_payments", "facility"],
        fakeParam: currentLang.value, //this is to force re-fetching data when language changes
      },
      permanentFilter: filter,
    });

  const columns = useMemo(
    () => [
      //{ field: "id", headerName: "Nr. prenotazione", flex: 1, minWidth: 100 },
      {
        field: "bookingDate",
        headerName: "Data prenotazione",
        flex: 1,
        minWidth: 100,
        valueGetter: ({ row }) => {
          const date = new Date(row.bookingDate);
          return date.toLocaleDateString("it-IT");
        },
      },
      {
        field: "nominativo",
        headerName: "Nominativo",
        flex: 1,
        minWidth: 100,
        valueGetter: ({ row }) => {
          return row.user.firstName + " " + row.user.lastName;
        },
      },
      {
        field: "arrivo",
        headerName: "Arrivo",
        flex: 1,
        minWidth: 100,
        valueGetter: ({ row }) => {
          const date = new Date(row.checkinDate);
          return date.toLocaleDateString("it-IT");
        },
      },
      {
        field: "partenza",
        headerName: "Partenza",
        flex: 1,
        minWidth: 100,
        valueGetter: ({ row }) => {
          const date = new Date(row.checkoutDate);
          return date.toLocaleDateString("it-IT");
        },
      },
      {
        field: "guests",
        headerName: "Nr. persone",
        flex: 1,
        minWidth: 50,
      },
      {
        field: "children",
        headerName: "Nr. bambini",
        flex: 1,
        minWidth: 50,
        valueGetter: ({ row }) => {
          let children = row.booking_items.reduce(
            (acc, current) => acc + current.children,
            0
          );
          return children;
        },
      },
      {
        field: "struttura",
        headerName: "Struttura",
        flex: 1,
        minWidth: 100,
        valueGetter: ({ row }) => {
          return row.facility.businessName;
        },
      },
      { field: "price", headerName: "Importo totale", flex: 1, minWidth: 100 },
      {
        field: "status",
        headerName: "Stato",
        flex: 1,
        minWidth: 200,
        renderCell: function render(params) {
          let status = params.row.booking_payments.every(
            (x) => x.status == "cancelled"
          )
            ? "cancelled"
            : params.row.booking_payments.some((x) => x.status == "cancelled")
            ? "partially_cancelled"
            : params.row.booking_payments.every((x) => x.status == "completed")
            ? "booked"
            : params.row.booking_payments.some((x) => x.status == "no_show")
            ? "no_show"
            : "pending";
          return (
            <Grid container justifyContent="center">
              <Chip
                label={
                  status === "cancelled"
                    ? "Annullata"
                    : status === "partially_cancelled"
                    ? "Parzialmente annullata"
                    : status === "booked"
                    ? "Completata"
                    : status === "no_show"
                    ? "No show"
                    : "In attesa"
                }
                color={
                  status === "cancelled"
                    ? "error"
                    : status === "partially_cancelled"
                    ? "warning"
                    : status === "booked"
                    ? "success"
                    : status === "no_show"
                    ? "warning"
                    : "info"
                }
              />
            </Grid>
          );
        },
      },
      {
        headerName: "Azioni",
        field: "actions",
        minWidth: 100,
        renderCell: function render(params) {
          return (
            <Stack direction="row" spacing={1}>
              <ShowButton hideText recordItemId={params.row.id} />
              {/*<EditButton hideText recordItemId={params.row.id} />
              <DeleteButton hideText recordItemId={params.row.id} />*/}
            </Stack>
          );
        },
      },
    ],
    []
  );

  return (
    <List
      resource="prenotazioni"
      headerButtons={() => {}}
      //headerButtonProps={{ size: "small" }}
      title={<Typography variant="h5">Prenotazioni</Typography>}
    >
      <DataGrid
        {...dataGridProps}
        localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
        columns={columns}
        sortingMode={sortingMode}
        sortModel={sortModel}
        onSortModelChange={onSortModelChange}
        autoHeight
      />
    </List>
  );
}
